export const DISPLAY_BASE = '/display';

export const displayPaths = {
  root: DISPLAY_BASE,
  create: `${DISPLAY_BASE}/create`,
  edit: `${DISPLAY_BASE}/edit`,
  mediaLibrary: `${DISPLAY_BASE}/media-library`,
  playlistCreate: `${DISPLAY_BASE}/media-library/playlists/create`,
} as const;
